module.exports = __webpack_public_path__ + "static/media/Mine.df7df454.png";